/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  CreateEncountersImagesBody,
  CreateImageErrorResponse,
  CreateImageResponse,
} from './api.schemas';

import { api } from '../util/http';

export const createEncountersImages = (
  encounterId: number,
  createEncountersImagesBody: CreateEncountersImagesBody,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, createEncountersImagesBody.file);
  if (createEncountersImagesBody.bodyLocation !== undefined) {
    formData.append(`bodyLocation`, createEncountersImagesBody.bodyLocation);
  }
  if (createEncountersImagesBody.description !== undefined) {
    formData.append(`description`, createEncountersImagesBody.description);
  }

  return api<CreateImageResponse>({
    url: `/api/encounters/${encounterId}/images`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getCreateEncountersImagesMutationOptions = <
  TError = CreateImageErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEncountersImages>>,
    TError,
    { encounterId: number; data: CreateEncountersImagesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEncountersImages>>,
  TError,
  { encounterId: number; data: CreateEncountersImagesBody },
  TContext
> => {
  const mutationKey = ['createEncountersImages'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEncountersImages>>,
    { encounterId: number; data: CreateEncountersImagesBody }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return createEncountersImages(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEncountersImagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEncountersImages>>
>;
export type CreateEncountersImagesMutationBody = CreateEncountersImagesBody;
export type CreateEncountersImagesMutationError = CreateImageErrorResponse;

export const useCreateEncountersImages = <TError = CreateImageErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEncountersImages>>,
      TError,
      { encounterId: number; data: CreateEncountersImagesBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEncountersImages>>,
  TError,
  { encounterId: number; data: CreateEncountersImagesBody },
  TContext
> => {
  const mutationOptions = getCreateEncountersImagesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
